exports.module = {
  profile: {
    description:
      'バンクーバー在住のフルスタックエンジニアです。React, Ruby on Rails, Go などでお仕事しています。職場がトロントなので日本、トロント、バンクーバーの三つの時天空を操って生活しています。',
    author: {
      description:
        'バンクーバー在住のフルスタックエンジニアです。React, Ruby on Rails, Go などでお仕事しています。職場がトロントなので日本、トロント、バンクーバーの三つの時天空を操って生活しています。'
    }
  },
  about: {
    profile: 'プロフィール',
    description: ''
  },
  messages: {
    'search-posts': '気になるサイト内の記事を検索する'
  },
  labels: {
    404: 'お探しのページが見つかりません。',
    articles: '記事一覧',
    'related-posts': '関連記事',
    'pop-posts': '人気記事',
    'latest-posts': '新着記事',
    search: '検索',
    'search-posts': '記事検索',
    pickup: 'Pick Up',
    share: 'シェア :',
    sidebar: {
      'profile-title': 'プロフィール',
      categories: 'カテゴリ',
      promotion: 'プロモーション',
      promotions: {
        menta: {
          title: 'MENTA',
          description:
            'MENTAでフロントエンドエンジニアを目指す方向けのサービスを提供しています。HTML/CSS, JS, Reactを学習できるコースを用意しています。詳細はこちらのリンク先でご確認下さい'
        },
        techpit: {
          title:
            'スネークゲームを作って学ぶReact Hooks APIでの状態管理 | Techpit',
          description:
            'オンラインプログラミング学習サービスTechpitさんでReact Hooks APIに関する教材を執筆・リリースさせて頂きました。スネークゲームを作りながらHooksを学べる教材になっています。'
        },
        'egg-cutter': {
          title: 'Egg Cutter | オンライン mp3 分割サービス',
          description:
            'ブラウザ上で音声を気軽に分割できるサービスです。英単語帳CD の分割にも使える便利なサービスになっているかと思います！'
        }
      },
      tags: 'タグ',
      'profile-description':
        'フリーランスのRails&Reactエンジニア10月からフルリモートになりました。プログラミング、旅行、フリーランスの働き方などについてぼちぼち更新していきます。',
      'profile-link': 'プロフィール',
      'freelance-title': 'フリーランスに関する記事',
      'archive-by-month': '月別アーカイブ'
    }
  },
  categories: {
    freelance: 'Freelance',
    career: 'Career',
    engineering: 'Engineering',
    design: 'Design',
    column: 'Column',
    'for-beginner': '初心者向け',
    rails: 'Ruby On Rails',
    react: 'React',
    travel: '旅行',
    'cryptocurrency-blockchain': '仮想通貨・ブロックチェーン'
  },
  tags: {
    ansible: 'Ansible',
    activerecord: 'ActiveRecord',
    book: '書籍',
    bitcoin: 'ビットコイン',
    blade: 'Blade',
    blockchain: 'ブロックチェーン',
    boostnote: 'Boostnote',
    'build-env': '環境構築',
    ci: 'CI',
    circleci: 'CircleCI',
    canada: 'カナダ',
    cakephp: 'CakePHP',
    career: 'キャリア',
    codesandbox: 'CodeSandbox',
    command: 'Command',
    codepen: 'Codepen',
    commentary: '解説',
    coolors: 'coolors.co',
    cryptocurrency: '仮想通貨',
    css: 'CSS',
    design: 'デザイン',
    'design-pattern': 'デザインパターン',
    docker: 'Docker',
    english: '英語',
    'egg-cutter': 'Egg Cutter',
    exposed: 'Exposed',
    editor: 'エディタ',
    electron: 'Electron',
    essay: 'エッセイ',
    ethereum: 'イーサリアム',
    freelance: 'フリーランス',
    frontend: 'フロントエンド',
    flyway: 'Flyway',
    ga: 'Google Analytics',
    gatsby: 'Gatsby',
    gadget: 'ガジェット',
    git: 'Git',
    go: 'GO',
    gin: 'Gin',
    gqlgen: 'gqlgen',
    gorm: 'Gorm',
    'hello-world': 'Hello World',
    inkdrop: 'Inkdrop',
    immersed: 'Immersed',
    javascript: 'Javascript',
    jest: 'Jest',
    kotlin: 'Kotlin',
    khttp: 'Khttp',
    laravel: 'Laravel',
    learning: '学習',
    lifehack: 'ライフハック',
    lubuntu: 'Lubuntu',
    lodash: 'Lodash',
    mac: 'Mac',
    marketing: 'マーケティング',
    migration: 'マイグレーション',
    mysql: 'MySQL',
    native: 'ネイティブ',
    netlify: 'Netlify',
    nginx: 'Nginx',
    nodejs: 'Node.js',
    opinion: 'オピニオン',
    oop: 'オブジェクト指向',
    oculus: 'Oculus',
    phantomjs: 'PhatomJS',
    prismjs: 'Prismjs',
    programming: 'プログラミング',
    php: 'PHP',
    phpunit: 'PHPUnit',
    plugin: 'プラグイン',
    product: 'Product',
    postgress: 'PostgresSQL',
    pomodoro: 'ポモドーロ',
    react: 'React',
    redux: 'Redux',
    'react-native': 'React Native',
    'react-navigation': 'React Navigation',
    rspec: 'Rspec',
    review: 'レビュー',
    rails: 'Rails',
    ruby: 'Ruby',
    spa: 'SPA',
    springboot: 'Spring Boot',
    slack: 'Slack',
    smaccs: 'SMACCS',
    snakegame: 'スネークゲーム',
    serverside: 'サーバーサイド',
    travel: '旅行',
    test: 'Test',
    tool: 'ツール',
    typescript: 'TypeScript',
    udemy: 'Udemy',
    vagrant: 'Vagrant',
    vr: 'VR',
    vue: 'Vue',
    vuex: 'Vuex',
    'web-structure': 'Webサイトの仕組み',
    vim: 'Vim',
    webpack: 'Webpack',
    wordpress: 'Wordpress',
    work: '仕事'
  }
}
